import { useEffect } from 'react';
import type { TServiceWorkerOptions } from './useServiceWorker.types.ts';

export const useServiceWorker = ({
  isEnabled,
  url,
}: TServiceWorkerOptions): void => {
  useEffect(() => {
    if (!isEnabled || !('serviceWorker' in navigator)) {
      return;
    }

    const register = () => {
      navigator.serviceWorker.register(url);
    };

    if (document.readyState === 'complete') {
      register();

      return;
    }

    window.addEventListener('load', register, { once: true });

    return () => {
      window.removeEventListener('load', register);
    };
  }, [isEnabled, url]);
};
